import firebase from "../firebase";
import { DbUser } from "../database/DbUser";
import { DbUtile } from "../database/DbUtile";

export class AuthUtile {
    private dbUtile = new DbUtile();
    private auth = firebase.auth();

    constructor() {
        console.log('constructor');
    }

    // ログイン認証
    public signInWithEmailAndPassword(email: string, password: string): Promise<DbUser> {
        return new Promise((resolve,reject) => {
            // 認証状態の永続性 設定
            this.auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                .then(() => {
                    // 認証処理 実行
                    return this.auth
                        .signInWithEmailAndPassword(email, password)
                        .then(() => {
                            const currentUser = this.auth.currentUser;
                            console.log("currentUser", currentUser);
                            if (currentUser){
                                console.log(" uid", currentUser.uid);
                                this.dbUtile.getUser(currentUser.uid)
                                    .then((user) => {
                                        resolve(user.u!);
                                    }).catch((e) => {
                                        //reject(e);
                                        // TODO DbUser 未登録のユーザの場合 管理者扱いとする
                                        const user = new DbUser();
                                        user.role = DbUser.ROLE.admin;
                                        resolve(user);
                                    });
                            }
                            else {
                                reject();
                            }
                        }).catch((e) =>{
                            reject(e);
                        });
                })
                .catch(function(error) {
                    reject(error);
                    // Handle Errors here.
                    // var errorCode = error.code;
                    // var errorMessage = error.message;
                });
        });
    }

    // ユーザーのログイン状態の監視
    public onAuthStateChanged(): Promise<firebase.User> {
        return new Promise((resolve, reject) => {
            this.auth.onAuthStateChanged(function(user) {
                if (user) {
                    resolve(user);
                }
                else {
                    reject();
                }
              });
        });
    }

    // ユーザーのログイン状態、管理者権限のチェック
    public checkAuthorizedAdmin(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.auth.onAuthStateChanged((currentUser) => {
                if (currentUser !== null) {
                    this.dbUtile.getUser(currentUser.uid)
                        .then((user) => {
                            if (user.u?.role === DbUser.ROLE.admin) {
                                resolve();
                            } else {
                                reject('管理者権限がありません');
                            }
                        }).catch((e) => {
                            // 協会アカウントはここに入る
                            resolve();
                        });
                } else {
                    reject('ログインしてください');
                }
            });
        });
    }

    public currentUser(): firebase.User | null {
        return this.auth.currentUser;
    }

    // 確認メール送信
    public static sendEmailVerification(src: firebase.User, isAdmin: boolean): Promise<firebase.User> {
        console.log("sendEmailVerification ", src);
        return new Promise((resolve,reject) => {
            let url = "http://" + window.location.host;
            url += (isAdmin) ? '/admin' : '/students/login';
            const actionCodeSettings = {url: url};
            src.sendEmailVerification(actionCodeSettings)
                .then(() => {
                    console.log("success", src);
                    resolve(src);
                })
                .catch((e) => {
                    console.error("error", e);
                    reject(e);
                });
        });
    }

    // パスワード再設定 メールを送信する
    public static sendPasswordResetEmail(auth: firebase.auth.Auth, email: string, isAdmin: boolean): Promise<void> {
        console.log("sendPasswordResetEmail ", email);
        return new Promise((resolve,reject) => {
            let url = "http://" + window.location.host;
            url += (isAdmin) ? '/admin' : '/students/login';
            const actionCodeSettings = {url: url};
            console.log(" actionCodeSettings", actionCodeSettings);
            auth.sendPasswordResetEmail(email, actionCodeSettings)
                .then(() => {
                    // Email sent.
                    console.log("success");
                    resolve();
                }).catch((error) => {
                    console.error("error", error);
                    reject(error);
                });
        });
    }
}
